import { language } from '../i18n/language.js';

/**
 * The legal pages in the player's language (ADR 0069). The English ones are a
 * courtesy translation; each says the French version is the binding one.
 */
export type LegalPage = 'terms-of-use' | 'terms-of-sale' | 'privacy' | 'legal-notice';

const FRENCH: Readonly<Record<LegalPage, string>> = {
  'terms-of-use': '/legal/cgu.html',
  'terms-of-sale': '/legal/cgv.html',
  privacy: '/legal/confidentialite.html',
  'legal-notice': '/legal/mentions-legales.html',
};

export function legalUrl(page: LegalPage): string {
  return language() === 'en' ? `/legal/en/${page}.html` : FRENCH[page];
}
